import  "./ldclient.min.js"
import deviceId from "../deviceId.ts";
import FizConfig from "../../FizConfig.ts";
import * as FwDatas from "../../FwDatas.ts";

const LDClient = (window as any).LDClient

const client = LDClient.initialize(FizConfig.LAUNCHDARKLY_CLIENTID, {
  kind: "multi",
  device: {
    key: deviceId,
    platform: "web",
    //appVersion: FizConfig.VERSION
  }
});
const readyPromise = client.waitForInitialization(5).catch(function (err) {
  console.error('LaunchDarkly init failed:', err);
});

export function isFeatureEnabled(flag : 'FWALL-33-list-item-quantity'){
  //return false;
  try{
    return client.variation(flag, false);
  }catch(e){
    console.log(e)
    return false;
  }
}
export async function launchDarklyReady(){
  return readyPromise.catch(console.log)
}
export async function launchDarklyIdentify(){
  const
    account = FwDatas.getUser(),
    family = FwDatas.getFamily(),
    state = FwDatas.getState();

  var context = ({
    kind: "multi",
    device: {
      key: deviceId,
      platform: "web",
      appVersion: FizConfig.VERSION
    },

    user: {
      key: account.accountId,
      email : account.identifiers.find(identifier=>identifier.type==='Email')?.value,
      locale : account.locale,
      timeZone: account.timeZone,
      role: account.role,
      creationDate:account.creationDate?.toISOString(),
      isPremiumSubscriber: !!state.premium.yourCredit,
      _meta: {
        privateAttributes: ["email"],
      },
    },

    circle: {
      key: family.family_id,
      memberCount: family.members.length,
      creationDate:family.creationDate?.toISOString(),
      isPremium: state.premium.filer==='OK'
    }
  });
  return client.identify(context)
}
